import { Button } from '@bambi/component-library/src/components/Button/Button';
import {
  MagnifyingGlassPlusIcon,
  MinusIcon,
  PlusIcon,
  ViewfinderCircleIcon,
} from '@heroicons/react/24/outline';
import { isEqual } from 'lodash-es';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import {
  dispatcherSlice,
  MobiscrollCellStepValues,
  possibleZoomLevelsInMinutes,
} from 'src/features/dispatch/dispatcher.slice';

export function ZoomControls() {
  const dispatch = useAppDispatch();
  const { canZoomIn, canZoomOut } = useAppSelector((state) => {
    const currentIndex = possibleZoomLevelsInMinutes.indexOf(
      state.dispatcher.calendarView.schedule
        ?.timeCellStep as MobiscrollCellStepValues
    );
    return {
      canZoomOut: currentIndex < possibleZoomLevelsInMinutes.length - 1,
      canZoomIn: currentIndex > 0,
    };
  }, isEqual);

  return (
    <div className="flex w-full items-center justify-between text-xs">
      <div className="flex items-center gap-2">
        <MagnifyingGlassPlusIcon className="h-4 w-4" />
        <div>Zoom</div>
      </div>
      <div className="flex items-center gap-1">
        <Button
          disabled={!canZoomOut}
          dataTestId="zoom-out-button"
          aria-label="Zoom Out"
          onClick={(e) => {
            e.stopPropagation();
            dispatch(dispatcherSlice.actions.onCalendarZoomOut());
          }}
          className="!p-0 py-2"
          variant="ghost"
        >
          <MinusIcon className="h-5 w-5" />
        </Button>
        <Button
          disabled={!canZoomIn}
          dataTestId="zoom-in-button"
          aria-label="Zoom In"
          onClick={(e) => {
            e.stopPropagation();
            dispatch(dispatcherSlice.actions.onCalendarZoomIn());
          }}
          className="!p-0 py-2"
          variant="ghost"
        >
          <PlusIcon className="h-5 w-5" />
        </Button>
        <div className="mx-1 h-4 w-[1px] bg-slate-400" />
        <Button
          dataTestId="reset-zoom-button"
          onClick={() => {
            dispatch(dispatcherSlice.actions.onCalendarZoomReset());
          }}
          className="!p-0 py-2"
          variant="ghost"
        >
          <ViewfinderCircleIcon className="h-5 w-5" />
        </Button>
      </div>
    </div>
  );
}
